import styled from '@emotion/styled';
import { darken } from 'polished';
import breakpoints from '../util/breakpoints';
import { scrollbarThumbColor } from '../util/sidebar-config';

export default styled.div(props => ({
  padding: '0px 0px',
  position: 'relative',
  marginTop: `0px`,
  [breakpoints.md]: {
    padding: '0px 10px'
  },
  [breakpoints.sm]: {
    padding: '0px 0px'
  }
}));

export const BackgroundImage = styled.div(props => ({
  position: `fixed`,
  display: `inline-block`,
  width: '100%',
  height: '100%',
  backgroundColor: props.theme.background,
  maskImage: `linear-gradient(to top, rgba(0,0,0,255), rgba(255,255,255,255))`,
  overflow: `hidden`,
  filter: `brightness(.15)`,
  backgroundSize: `cover`,
  backgroundPosition: `top`,
  backgroundImage: props.uri ? `url(${props.uri})` : `none`
}));

// eslint-disable-next-line no-unused-vars
export const OuterContentWrapper = styled.div(props => ({
  position: `relative`,
  flexGrow: 1,
  outline: 'none',
  width: '100%',
  overflowY: 'auto',
  paddingTop: `50px`,
  minWidth: '320px',
  [breakpoints.md]: {
    [`::-webkit-scrollbar`]: {
      width: '0px',
      background: `inherit`
    },
    [`::-webkit-scrollbar-thumb`]: {
      background: `inherit`
    }
  },
  [`::-webkit-scrollbar`]: {
    width: '4px',
    background: `black`
  },
  [`::-webkit-scrollbar-thumb`]: {
    background: darken(0.5, scrollbarThumbColor)
  },

  boxSizing: 'border-box'
}));
